import Repository from "../Repository";
export default {
  getStoreSettings: () => {
    return Repository.get('/store-setting');
  },

  updateStoreSettings: (data) => {
    return Repository.put('/store-setting', data);
  },
};
